import { useGlobalUserProfile } from "@shared/hooks/useGlobalUser";
import { useGlobalUtility } from "@shared/hooks/useGlobalUtility";

export const useTenantId = () => {
  const { data: userProfile } = useGlobalUserProfile();
  return userProfile?.utility?.tenant?.id?.toString() ?? null;
};
export const useUserName = () => {
  const { data: userProfile } = useGlobalUserProfile();
  return userProfile?.user?.name ?? null;
};

export const useCurrency = () => {
  const { data: userProfile } = useGlobalUserProfile();
  return userProfile?.utility?.tenant?.currency?.toString() ?? null;
};

export const useCountry = () => {
  const { data: userProfile } = useGlobalUserProfile();
  return (
    userProfile?.utility?.tenant?.extraDataMap?.country?.toString() ?? null
  );
};

export const useRemoteUtilityId = () => {
  let localUtilityId = null;
  const utilityData = localStorage.getItem("utility");
  const { data: utility } = useGlobalUtility();

  if (utilityData) {
    try {
      const parsedUtility = JSON.parse(utilityData);
      localUtilityId = parsedUtility?.id ?? null;
    } catch (e) {
      console.error("Failed to parse utility from localStorage:", e);
    }
  }
  return String(utility?.id ?? localUtilityId ?? "");
};

export const useRemoteUtilityName=()=>{
  let localUtilityName=null;
  const utilityData=localStorage.getItem("utility");
  const {data:utility}=useGlobalUtility();
  if(utilityData){
    try{
      const parsedUtility=JSON.parse(utilityData);
      localUtilityName=parsedUtility?.name??null;
    }catch(e){
      console.error("Failed to parse utility from localStorage:",e);
    }
  }
  return String(utility?.name??localUtilityName??"");
}
export const useUtilityAlias = () => {
  let localUtilityAlias = null;
  const utilityData = localStorage.getItem("utility");
  const { data: utility } = useGlobalUtility();
  if (utilityData) {
    try {
      const parsedUtility = JSON.parse(utilityData);
      localUtilityAlias = parsedUtility?.alias ?? null;
    } catch (e) {
      console.error("Failed to parse utility from localStorage:", e);
    }
  }
  return String(utility?.alias ?? localUtilityAlias ?? "");
};
export const useUserId = () => {
  const { data: userProfile } = useGlobalUserProfile();
  console.log("Data of user", userProfile);
  return userProfile?.id.toString() ?? null;
};

export const useDateFormat = () => {
  const { data: userProfile } = useGlobalUserProfile();
  return userProfile?.utility?.tenant?.dateFormat ?? "DD/MM/YYYY";
};

